import React from 'react';

const AboutUs = () => {
  return (
    <section id="about" className="bg-[#F1EFE8] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Image */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/86ro7s5j_AdobeStock_722441630.jpeg"
                alt="Compassionate Care - Smile a Pal"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#2C2C2A] tracking-tight">
              About Us
            </h2>

            <div className="space-y-5 text-lg text-[#6B6B69] leading-relaxed">
              <p>
                <strong className="text-[#2C2C2A]">Smile A Pal</strong> is a specialist provider of home care services and support for people living with a disability or illness and the elderly.
              </p>

              <p>
                Established in 2024, Smile A Pal is a fully owned Australian business dedicated to helping people lead fulfilling and independent lives.
              </p>

              <p>
                Our vision is to deliver the highest level of care to vulnerable members of our community. We pride ourselves on creating a safe and nurturing environment, providing professional support to those in need.
              </p>
            </div>

            <div className="pt-6">
              <a
                href="#contact"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-[#0F6E56] text-white rounded-full hover:bg-[#0d5c48] transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <span>Get in Touch</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
